<template>
    <div>
        <div class="row row-space-top">
            <div class="col-size-auto">
                <h2 class="subtitle">{{ formatBrand(table.brand) }}</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-size-auto">
                <p v-html="textByBrand(showroomText, table.brand)"></p>
            </div>
        </div>
        <table v-if="table.carModels.length > 0" class="table-list">
            <thead class="sticky-thead">
                <tr>
                    <th  ></th>
                    <th  >
                        <a class="table-sorting-cta" v-on:click="sortBy('modelName')" :class="sortDirectionCssClass('modelName')">
                            Model
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>
                    <!--<th  >
                        <a class="table-sorting-cta" v-on:click="sortBy('ModelVariant')" :class="sortDirectionCssClass('ModelVariant')">
                            Variant
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>-->
                    <th  class="align-right">
                        <a class="table-sorting-cta" v-on:click="sortBy('taxBase')" :class="sortDirectionCssClass('taxBase')">
                            Beskatning fra
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>
                    <th   style="max-width: 6rem;">
                        <a v-if="excelButtonVisible" :href="downloadLink" class="button has-icon">
                            Hent excel prisliste
                            <svg width="18" height="18" class="icon icon-md">
                                <use href="/ui/icons/custom-sprite.svg#feather-download"></use>
                            </svg>
                        </a>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(carModel, index) in table.carModels" :key="carModel.id + '_' + table.brand + '_' + index">
                    <td class="photo">
                        <a v-bind:href="setModelPageUrl(carModel)" class="rowlink"></a>
                        <img :src="carModel.imageUrl ? carModel.imageUrl : ('/ui/logos/' + table.brand + '.svg')"
                             alt="image"
                             loading="lazy"
                             @error="e => {
                                if (table.brand == 'cupra') return;
                                let fallback = '/ui/logos/' + table.brand;
                                if (table.brand == 'porsche') {
                                    fallback += '.png';
                                } else {
                                    fallback += '.svg';
                                }
                                if (e.target.src !== fallback) e.target.src = fallback;
                              }" />
                    </td>
                    <td >
                        <a v-bind:href="setModelPageUrl(carModel)" class="rowlink"></a>
                        <span :class="setCssClassForLongString(carModel.modelName)">{{ carModel.modelName }}</span>
                    </td>
                    <!--<td >
                        <a v-bind:href="setModelPageUrl(carModel)" class="rowlink"></a>
                        <span :class="setCssClassForLongString(carModel.ModelVariant)">{{ carModel.modelVariant }}</span>
                    </td>-->
                    <td class="align-right">
                        <a v-bind:href="setModelPageUrl(carModel)" class="rowlink"></a>
                        {{ carModel.taxBaseInPriceFormat }} kr.
                    </td>
                    <td class="align-right" v-if="carModel.tooltipHeadline && carModel.tooltipText">
                        <div class="tooltip">
                            
                            <a class="tooltip-cta">
                                <svg width="20" height="20" class="icon">
                                    <use href="/ui/icons/custom-sprite.svg#feather-info"></use>
                                </svg>
                            </a>

                            <article class="tooltip-target">
                                <h3 class="tooltip-title">{{ carModel.tooltipHeadline }}</h3>
                                <div class="tooltip-text" v-html="carModel.tooltipText">
                                </div>
                            </article>

                        </div>
                    </td>
                    <td  v-else></td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="100" v-html="textByBrand(overviewterms, table.brand)"></td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>
<script>
    import _ from 'lodash';
    import formatMixin from '../mixins/formatter.js';

    export default {
        name: 'model-overview-table',
        mixins: [formatMixin],
        props: {
            tableData: {
                type: Object,
                default: undefined
            },
            showroomText: {
                type: Object,
                default: undefined
            },
            overviewterms: {
                type: Object,
                default: undefined
            },
            excelLink: {
                type: String,
                default: undefined
            },
            excelButtonVisible: {
                type: Boolean,
                default: undefined
            }
        },
        data() {
            return {
                sortKey: 'ModelName',
                reverseOrder: false
            }
        },
        computed: {
            downloadLink: function () {
                const params = this.$props.tableData.carModels
                    .map(x => `ids=${x.modelPageId}`)
                    .join('&');
                return `${this.$props.excelLink}?${params}`;
            },
            table: function () {
                if (this.$props.tableData) {
                    let brandTable = this.$props.tableData;
                    brandTable.carModels = _.orderBy(brandTable.carModels, this.$data.sortKey, this.$data.reverseOrder ? 'desc' : 'asc');

                    return brandTable;
                }

                return undefined;
            },
        },
        methods: {            
            sortBy: function (sortKey) {
                this.reverseOrder = (this.sortKey == sortKey) ? !this.reverseOrder : true;
                this.sortKey = sortKey;
            },
            sortDirectionCssClass: function (sortKey) {
                let cssClass = '';

                if (this.sortKey === sortKey) {
                    cssClass += 'is-selected';
                }

                if (this.sortKey === sortKey && !this.reverseOrder) {
                    cssClass += ' is-pointing-up';
                }

                return cssClass;
            },
            setModelPageUrl: function (carModel) {
                if (carModel.modelPageUrl) {
                    return `${carModel.modelPageUrl}`;
                }

                return '';
            },
            setCssClassForLongString: function (string) {
                if (string.length > 20) {
                    return 'wrap-text';
                }

                return '';
            }
        }
    }
</script>